import { HuellFeatureFlagsAdminApi } from './huellFeatureFlagsAdmin.api';

export const HuellAdminApi = {
  ...HuellFeatureFlagsAdminApi,
};
